<div class="hidden bg-white p-6 border-b border-grey-200 md:block">
  <div class="flex items-center justify-between gap-4">
    <div class="relative inline-flex w-full min-w-[300px] max-w-[400px] bg-grey-bg rounded-full">
      <input
        class="rounded-full w-full py-3 px-10 text-grey-600 text-sm border border-grey-200"
        (ngModelChange)="searchTerm$.next($event)"
        [ngModel]="searchTerm$.value"
        (input)="handlePopover($event)"
        (focusin)="handlePopover($event)"
        (focusout)="popover.hide()"
        name="search"
        type="text"
        [placeholder]="'toolbar.searchPlaceholder' | transloco"
      />

      <div class="absolute left-[4px] top-[5px] flex items-center justify-center h-9 w-9">
        <i class="pi pi-search w-4 h-4" style="font-size: 14px;"></i>
      </div>

      @if (searchTerm$ | async) {
        <button class="absolute right-[4px] top-[5px] flex items-center justify-center h-9 w-9 cursor-pointer" (click)="onClearSearch()">
          <i class="pi pi-times w-4 h-4" style="font-size: 14px;"></i>
        </button>
      }

      <p-popover #popover>
        <div class="w-[25rem] max-h-[25rem] overflow-y-auto p-8">
          <app-search-results />
        </div>
      </p-popover>
    </div>

    <div class="flex items-center space-x-3">
      <button class="flex items-center justify-center h-9 w-9 border border-grey-400 bg-grey-bg rounded-full cursor-pointer">
        <i class="pi pi-refresh w-4 h-4"></i>
      </button>
      <button class="relative flex items-center justify-center h-9 w-9 border border-grey-400 bg-grey-bg rounded-full cursor-pointer" (click)="handleOpenNotifications()">
        @if (hasUnreadNotifications$ | async) {
          <div class="absolute top-0 right-0 -translate-x-1.25 translate-y-1.2 flex items-center justify-center bg-red-icon rounded-full min-w-3 h-3 border border-grey-bg"></div>
        }
        <i class="pi pi-bell w-4 h-4"></i>
      </button>
    </div>
  </div>
</div>
